import PropTypes from 'prop-types';

export const imageEntityPropShape = PropTypes.shape({
  entityLabel: PropTypes.string,
  mediaImage: PropTypes.shape({
    alt: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired,
  contributor: PropTypes.string,
  credit: PropTypes.string,
  caption: PropTypes.string
});
